
<div class="avatar-initials" [ngClass]="extraClass" [ngStyle]="{'background-color':  circleColor }">
    <div class="initials">
        {{ initials }}
    </div>
</div>